// Angular modules
import { Routes } from '@angular/router';
import { authMatchGuard } from '@guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.routes').then(m => m.authRoutes)
  },
  {
    path: 'home',
    canMatch: [authMatchGuard],
    loadChildren: () => import('./pages/home/home.routes').then(m => m.homeRoutes)
  },
  {
    path: 'invoices',
    canMatch: [authMatchGuard],
    loadChildren: () => import('./pages/invoice/invoice.routes').then(m => m.invoiceRoutes)
  },
  {
    path: 'report',
    canMatch: [authMatchGuard],
    loadChildren: () => import('./pages/report/report.routes').then(m => m.reportRoutes)
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
  },
];